import { Button, Group, Modal } from "@mantine/core";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";
import { SiteName } from "../../../utils/enums";
import { AnchorLink } from "../../AnchorLink/AnchorLink";

declare const SITE_NAME: SiteName;

type NotAccessableModalProps = {
  onClose: () => void;
  text?: string;
};

function NotAccessableModal({ onClose, text }: NotAccessableModalProps) {
  let SupportLink = <></>;
  if (SITE_NAME === SiteName.Optinode) {
    SupportLink = (
      <AnchorLink href="mailto:support@node.energy" target="_self">
        support@node.energy
      </AnchorLink>
    );
  }
  if (SITE_NAME === SiteName.Smarendo) {
    SupportLink = (
      <AnchorLink href="mailto:smarendo@node.energy" target="_self">
        smarendo@node.energy
      </AnchorLink>
    );
  }

  return (
    <Modal opened title="Kein Zugriff" onClose={onClose}>
      <Group>
        {!text
          ? "Diese Option steht derzeit nicht zur Verfügung, da die Konfiguration " +
            "als vollständig bestätigt wurde. Wenden Sie sich für Änderungen an das " +
            "Support Team: "
          : text}
        {SupportLink}
      </Group>
      <ModalFooter>
        <Button variant="default" onClick={onClose}>
          Zurück
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { NotAccessableModal };
